import React, { PureComponent } from 'react';
import styled from 'styled-components';

// Atoms
import { Description, MediumTitle } from '../components/Atoms/Texts';
// Components
import MetaDescription from '../components/Molecules/MetaDescription';
import Game from '../components/modules/games';
import { BaseWrapper, BasicWrapper, MaxWidthWrapper } from '../components/Atoms/Wrappers';
import { LineBreak, Divider } from '../components/Atoms/Dividers';

const GameTitle = styled(MediumTitle)`
	margin-top: 10px;
	font-size: 25px;
	text-align: center;
`;

const GameDescription = styled(Description)`
	margin: 20px 0 30px 0;
	padding: 0px 30px;
`;

class Games extends PureComponent {
	render() {
		return (
			<BaseWrapper>
				<MetaDescription
					page={{
						meta: {
							title: '100 Boxes - The Game',
							metaDescription: 'Looking for a fun game to pass the time? Check it out and click on all 100 boxes if you can.',
						},
					}}
				/>
				<BasicWrapper>
					<MaxWidthWrapper center>
						<GameTitle>100 Boxes</GameTitle>
						<GameDescription>
							Your goal in classic mode is to click on all 100 boxes. There is a predefined pattern of
							available boxes to click.
							<LineBreak />
							You lose game when you do not have any more boxes to click on.
						</GameDescription>
						<GameDescription>
							To start the game just click on any field
						</GameDescription>
						<Game />
					</MaxWidthWrapper>
				</BasicWrapper>
			</BaseWrapper>
		);
	}
}

export default Games;
